import script from "./AddSecondSaleCategoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSecondSaleCategoryModal.vue?vue&type=script&setup=true&lang=js"

import "./AddSecondSaleCategoryModal.vue?vue&type=style&index=0&id=17a38636&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a38636"]])

export default __exports__